<template>
  <a class="blog__articles-badge" :href="categoryUrl" :style="badgeStyles" v-text="category.name"></a>
</template>

<script>
    export default {
        name: "CategoryBadge",
        props: {
            category: {
                type: Object,
                required: true
            }
        },
        computed: {
            
            badgeStyles(){
                return {
                    'background': this.category.bg_color ?? 'green'
                }
            },

            categoryUrl(){
                return `/blog/${this.category.slug}`
            }

        }
    }
</script>
